import React from "react";
import "./css/Landing.css";

export default function Landing() {
  return (
    <div className="landing">
      <div
        className="container"
        style={{
          maxWidth: "1500px",
          padding: "0",
        }}
      >
        <div className="row align-items-start">

          {/* LEFT: Main message */}
          <div className="col-md-6 mb-5 mb-md-0">

             <h1 className="landing-kicker">
    Beginner Guitar Lessons in West Sussex
  </h1>


            <p className="landing-intro">
              I’m Arthur — a guitarist and tutor based in Sussex. I focus on
              helping beginners feel comfortable, build solid technique, and
              actually enjoy practicing from the start.
            </p>

            <p className="landing-intro">
              Lessons are tailored to your goals, pace, and musical interests.
            </p>

            {/* CTA */}
            <div className="d-flex flex-column flex-sm-row gap-3 mt-4">
              <a href="/booking" className="btn btn-primary btn-lg shadow-sm">
                Book a Free Trial Lesson
              </a>

              <a href="tel:07952276343" className="btn btn-outline-dark btn-lg">
                Call 07952 276343
              </a>
            </div>
          </div>

          {/* RIGHT: Image + supporting info */}
          <div className="col-md-6 text-center">

            <img
              src="/img/me-playing-guitar.jpg"
              alt="Arthur playing guitar"
              className="img-fluid rounded shadow-lg landing-image mb-4"
            />

            {/* Supporting info moved here */}
        

              <div className="pricing-box p-2 rounded shadow-sm">
                <h5 className="support-title"><strong>Free Intro Lesson</strong></h5>
                <p className="mb-1">
                  Individual lessons from <strong>£25</strong>
                </p>
          
              </div>

            

            </div>
          <div className="row mt-4">
          <div className="col-12 text-center">
            <p className="testimonial-text fst-italic">
              “Friendly, patient and makes lessons relaxed and stress-free —
              I’ve made solid progress as a beginner.”
            </p>
          </div>
        </div>

        </div>
      </div>
    </div>
  );
}